import DatePickerWrapper from '../../../../components/DatePicker/DatePickerWrapper';
import React, {useEffect, useState} from "react";
import "./etapes.css";
import { Card, Checkbox, Chip, CircularProgress, FormControl, FormHelperText, InputLabel, MenuItem, OutlinedInput, Select, TextField, Grid } from '@mui/material';
import SocieteModal from "./SocieteModal";
import { Autocomplete } from "@mui/material";
import { getAll } from "../../../../services/SocieteService";
import { getConsultantsAndManagers } from "../../../../services/UserService";
import { Box } from '@mui/material';
import Input from "react-phone-number-input";
import "react-phone-number-input/style.css";
import useDebounce from "../../../../utils/useDebounce";
import { v4 } from "uuid";
import { sources } from "../../../../utils/SourceUtil";
import { contrats, contratLabel, parseContrats, serializeContrats } from "../../../../utils/ContratUtil";
import {getLocations, addLocation} from "../../../../services/CandidatService";

export const Etape1 = ({
  linkedin,
  titre,
  nom,
  prenom,
  telephone,
  email,
  employeur,
  fonction,
  datedebut,
  seniorite,
  manager,
  talentManager,
  sourceur,
  sachezque,
  setLinkedin,
  setTitre,
  setPrenom,
  setNom,
  setTelephone,
  setEmail,
  setEmployeur,
  setFonction,
  setDateDebut,
  setSeniorite,
  handleTimeChange,
  setManager,
  setTalentManager,
  setSourceur,
  setSachezQue,
  errors,
  setErrors,
  snackbarShowMessage,
  source,
  setSource,
  localisation,
  setLocalisation,
  status,
  setStatus,
  avatar,
  setAvatar

}) => {
  const [open, setOpen] = useState(false);
  const [loadUsers, setLoadUsers] = useState(true);
  const [managers, setManagers] = useState([]);
  const [talentManagers, setTalentManagers] = useState([]);
  const [deliveryManagers, setDeliveryManagers] = useState([]);
  const [sachezQueCounter, setSachezQueCounter] = useState(
    300 - sachezque?.length
  );
  const [firstChar, setFirstChar] = useState("");
  const debouncedSearch = useDebounce(firstChar, 1000);
  const [societeData, setSocieteData] = useState({
    data: [],
    isLoading: false,
  });
  const [villes, setVilles] = useState([]);
  const [inputValue, setInputValue] = useState('');

  const setSocieteDataValue = (data = [], isLoading = true) => {
    setSocieteData({
      data,
      isLoading,
    });
  };

  useEffect(() => {
    setSocieteDataValue();
    const searchParam =
      debouncedSearch !== "" ? `?firstChar=${debouncedSearch}` : "";
    getAll(searchParam)
      .then(({ data }) => {
        setSocieteDataValue(data, false);
      })
      .catch((error) => {
        snackbarShowMessage(
          "Erreur de chargement du des sociétés.",
          "error",
          4000
        );
        setSocieteDataValue();
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch]);

  // Réinitialiser l'avatar si le source change (source != linkedin)
  useEffect(() => {
    if (source != 1 && source != 6) {
      setAvatar("");
    }
  }, [source]);

  useEffect(() => {
    let active = true;
    window.scrollTo({ top: 0, behavior: "smooth" });

    (async () => {
      setLoadUsers(true);
      try {
        const managerData = await getConsultantsAndManagers();
        const deliveryData = await getConsultantsAndManagers('ROLE_DELIVERY_MANAGER');
        const talentData = await getConsultantsAndManagers('ROLE_TALENT_MANAGER');
        if (!active) {
          return;
        }
        setManagers(managerData.data.managers);
        setDeliveryManagers(deliveryData.data.managers);
        setTalentManagers(talentData.data.managers);
        setLoadUsers(false);
      } catch (error) {
        if (!active) {
          return;
        }
        setOpen(true);
        snackbarShowMessage(
          "Erreur de chargement des consultants et managers.",
          "error",
          4000
        );
        setLoadUsers(false);
      }
    })();

    return () => {
      active = false;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        const locations = await getLocations();
        setVilles(locations.data);
      } catch (error) {
        console.error('Error fetching locations:', error);
      }
    };

    fetchLocations();
  }, [inputValue]);

  const handleAddCity = async () => {
    if (inputValue.trim() && !villes.find(ville => ville.name.toLowerCase() === inputValue.toLowerCase())) {
      try {
        const newCity = await addLocation({ name: inputValue });
        setVilles(prev => [...prev, newCity]);
        setLocalisation(newCity.uuid);
        setInputValue('');
      } catch (error) {
        console.error('Error adding city:', error);
      }
    }
  };
  const handleChangeSociete = (event) => {
    setFirstChar(event.target.value);
  };

  return (
    <>
      <Grid item xs={12} sm={6} md={6} xl={6} className="candidate-section-identity">
        <Card className="cards" style={{ height: "100%" }}>
          <h4>IDENTITÉ</h4>
          <label className="input-label" htmlFor="idCandidat">
            TITRE <span className="required-input">*</span>
          </label>
          <FormControl variant="outlined" fullWidth={true} margin="normal">
            <InputLabel
              {...(errors.titre && {
                error: true,
              })}
              shrink
            >
              {errors.titre}
            </InputLabel>
            <Select
              value={titre?.trim()}
              name="titre"
              onChange={(e) => setTitre(e.target.value)}
              {...(errors.titre && {
                error: true,
              })}
              input={
                <OutlinedInput
                  name="titre"
                  {...(errors.titre && {
                    labelWidth: 230,
                  })}
                  notched
                ></OutlinedInput>
              }
            >
              <MenuItem value={"Mr"}>Mr</MenuItem>
              <MenuItem value={"Mme"}>Mme</MenuItem>
            </Select>
          </FormControl>
          <label className="input-label" htmlFor="prenom">
            PRÉNOM<span className="required-input">*</span>
          </label>
          <TextField
            onChange={(e) =>
              setPrenom(e.target.value.replace(/^\w/, (c) => c.toUpperCase()))
            }
            name="prenom"
            value={prenom}
            placeholder="Prenom du candidat."
            margin="normal"
            variant="outlined"
            autoComplete="off"
            fullWidth={true}
            {...(errors.prenom && {
              error: true,
              label: errors.prenom,
            })}
          />
          <label className="input-label">
            NOM<span className="required-input">*</span>
          </label>
          <TextField
            name="nom"
            value={nom}
            onChange={(e) => setNom(e.target.value.toUpperCase())}
            margin="normal"
            variant="outlined"
            autoComplete="off"
            fullWidth={true}
            placeholder="Nom du candidat."
            {...(errors.nom && {
              error: true,
              label: errors.nom,
            })}
          />
          <label className="input-label">
            TÉLÉPHONE<span className="required-input"></span>
          </label>
          <Input
            defaultCountry="FR"
            onChange={setTelephone}
            name="telephone"
            value={telephone}
            margin="normal"
            variant="outlined"
            autoComplete="off"
            {...(errors.telephone && {
              error: true,
              label: errors.telephone,
            })}
          />
          <label className="input-label">
            EMAIL<span className="required-input">*</span>
          </label>
          <TextField
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            margin="normal"
            variant="outlined"
            autoComplete="off"
            fullWidth={true}
            placeholder="Email du candidat."
            {...(errors.email && {
              error: true,
              label: errors.email,
            })}
          />
          <label className="input-label">
            LINKEDIN<span className="required-input">*</span>
          </label>
          <span class="specification-label">(Sales Navigator interdit)</span>
          <TextField
            name="linkedin"
            value={linkedin}
            onChange={(e) => setLinkedin(e.target.value)}
            margin="normal"
            variant="outlined"
            autoComplete="off"
            fullWidth={true}
            placeholder="https://linkedin.com/in/profile."
            {...(errors.linkedin && {
              error: true,
              label: errors.linkedin,
            })}
          />
          <label className="input-label" htmlFor="source">
            SOURCE<span className="required-input">*</span>
          </label>
          <Box>
            <Select
              value={source}
              name="source"
              fullWidth
              onChange={(e) => setSource(e.target.value)}
              {...(errors.source && {
                error: true,
              })}
              input={
                <OutlinedInput
                  name="source"
                  {...(errors.source && {
                    error: true,
                  })}
                  notched
                ></OutlinedInput>
              }
            >
              {
                sources.map((source) => (
                  <MenuItem value={source.id} key={v4()}>
                    <span style={{ textTransform: "capitalize" }}>
                      {source.name}
                    </span>
                  </MenuItem>
                ))
              }
            </Select>
            <FormHelperText ><Box sx={{ color: "red" }}>{errors.source}</Box></FormHelperText>
          </Box>

          {(source == 1 || source == 6) && (
            <>
              <label className="input-label" htmlFor="avatar">
                AVATAR<span className="required-input">*</span>
              </label>
              <FormControl variant="outlined" fullWidth={true} margin="normal">
                <InputLabel
                  {...(errors.avatar && {
                    error: true,
                  })}
                  shrink
                >
                  {errors.avatar}
                </InputLabel>
                {loadUsers ? (
                  <Box display="flex" justifyContent="center">
                    <CircularProgress />
                  </Box>
                ) : (
                  <Select
                    value={avatar}
                    name="avatar"
                    onChange={(e) => setAvatar(e.target.value)}
                    {...(errors.avatar && {
                      error: true,
                    })}
                    input={
                      <OutlinedInput
                        name="avatar"
                        {...(errors.avatar && {
                          labelWidth: 290,
                        })}
                        notched
                      ></OutlinedInput>
                    }
                  >
                    {loadUsers ? (
                      <CircularProgress />
                    ) : (
                      managers?.map((avatar) => (
                        <MenuItem value={avatar.uuid} key={avatar.uuid}>
                          <span style={{ textTransform: "capitalize" }}>
                            {avatar.user}
                          </span>
                        </MenuItem>
                      ))
                    )}
                  </Select>
                )}
              </FormControl>
            </>
          )}

          <label className="input-label" htmlFor="status">
            CONTRAT
          </label>
          <Box>
            <Select
              multiple
              value={parseContrats(status)}
              name="status"
              fullWidth
              displayEmpty
              // Several contracts allowed: kept as "CDI,Freelance" in the form state
              onChange={(e) => setStatus(serializeContrats(e.target.value))}
              renderValue={(selected) => selected.length === 0 ? (
                <span style={{ color: "#94a3b8" }}>Choisir un ou plusieurs contrats…</span>
              ) : (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {selected.map((id) => (
                    <Chip key={id} label={contratLabel(id)} size="small"
                      sx={{ background: "#ebf4fb", color: "#03407b", fontWeight: 600, border: "1px solid #aed6f1" }} />
                  ))}
                </Box>
              )}
              {...(errors.status && {
                error: true,
              })}
              input={
                <OutlinedInput
                  name="status"
                  {...(errors.status && {
                    error: true,
                  })}
                  notched
                ></OutlinedInput>
              }
            >
              {
                contrats.map((contrat) => (
                  <MenuItem value={contrat.id} key={contrat.id}>
                    <Checkbox size="small" checked={parseContrats(status).includes(contrat.id)} sx={{ p: 0.5, mr: 1 }} />
                    <span style={{ textTransform: "capitalize" }}>
                      {contrat.name}
                    </span>
                  </MenuItem>
                ))
              }
            </Select>
            <FormHelperText><Box sx={{ color: "red" }}>{errors.status}</Box></FormHelperText>
          </Box>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} md={6} xl={6} className="candidate-section-profile">
        <Card className="cards">
          <h4>PROFIL ET ATTRIBUTION</h4>
          <label className="input-label" htmlFor="idCandidat">
            SOCIÉTÉ<span className="required-input"></span>
          </label>
          <SocieteModal
            errors={errors}
            setErrors={setErrors}
            snackbarShowMessage={snackbarShowMessage}
            societeData={societeData}
            setEmployeur={setEmployeur}
          />
          <Autocomplete
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            getOptionSelected={(option, value) => option.uuid === value.uuid}
            getOptionLabel={(option) => option.nomSociete}
            onChange={(event, values) => {
              setEmployeur(values);
            }}
            options={societeData.data}
            loading={societeData.isLoading}
            loadingText={"Chargement en cours..."}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                fullWidth={true}
                margin="normal"
                onChange={handleChangeSociete}
                placeholder={employeur ? employeur.nomSociete : ""}
                {...(errors.employeur && {
                  error: true,
                  label: errors.employeur,
                })} slotProps={{ ...params.slotProps, input: { ...params.slotProps?.input, ...({
                  ...params.slotProps.input,
                  endAdornment: (
                    <React.Fragment>
                      {params.slotProps.input?.endAdornment}
                    </React.Fragment>
                  ),
                }) } }}
              />
            )}
          />
          <label className="input-label">
            FONCTION <span className="required-input">*</span>
          </label>
          <TextField
            name="fonction"
            value={fonction}
            onChange={(e) => setFonction(e.target.value)}
            margin="normal"
            variant="outlined"
            autoComplete="off"
            fullWidth={true}
            placeholder="Fonction du candidat."
            {...(errors.fonction && {
              error: true,
              label: errors.fonction,
            })}
          />
          <label className="input-label" htmlFor="idCandidat" style={{marginTop: "25px"}}>
            DATE DÉBUT EXPÉRIENCE <span className="required-input">*</span>
          </label>
          <br/>
          <DatePickerWrapper
            views={["year"]}
            invalidDateMessage=""
            autoOk={true}
            variant="inline"
            format="yyyy"
            inputVariant="outlined"
            margin="normal"
            value={datedebut}
            onChange={(value) => handleTimeChange(value)}
            disableFuture
            fullWidth
            error={!!errors.datedebut}
            helperText={errors.datedebut}
            sx={{ width: "100%" }}
          />
          <br/>
          <label className="input-label" htmlFor="idCandidat">
            SENIORITÉ<span className="required-input"></span>
          </label>
          <TextField
            value={seniorite}
            fullWidth={true}
            variant="outlined"
            placeholder="Nombre d'année d'expérience."
            margin="normal"
            {...(errors.seniorite && {
              error: true,
              label: errors.seniorite,
            })} slotProps={{ input: {
              readOnly: true,
            } }}
          />
          <label className="input-label" htmlFor="localisation">
            LOCALISATION
          </label>
          <Box>
            <Autocomplete
                options={villes}
                getOptionLabel={(option) => option.name}
                onChange={(event, value) => {
                  if (value) {
                    setLocalisation(value.uuid);
                    setInputValue(value.name);
                  } else {
                    setLocalisation(null);
                    setInputValue("");
                  }
                }}
                onInputChange={(event, newInputValue) => {
                  setInputValue(newInputValue);
                }}
                value={villes.find(ville => ville.uuid === localisation) || null}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            handleAddCity();
                          }
                        }}
                    />
                )}
            />
          </Box>

          <label className="input-label" htmlFor="idCandidat">
            DELIVERY MANAGER
          </label>
          <FormControl variant="outlined" fullWidth={true} margin="normal">
            <InputLabel
              {...(errors.consultant && {
                error: true,
              })}
              shrink
            >
              {errors.consultant}
            </InputLabel>
            {loadUsers ? (
              <Box display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            ) : (
              <Select
                value={manager}
                name="manager"
                onChange={(e) => setManager(e.target.value)}
                {...(errors.consultant && {
                  error: true,
                })}
                input={
                  <OutlinedInput
                    name="manager"
                    {...(errors.consultant && {
                      labelWidth: 290,
                    })}
                    notched
                  ></OutlinedInput>
                }
              >
                {loadUsers ? (
                  <CircularProgress />
                ) : (
                  deliveryManagers.map((manager) => (
                    <MenuItem value={manager.uuid} key={manager.uuid}>
                      <span style={{ textTransform: "capitalize" }}>
                        {manager.user}
                      </span>
                    </MenuItem>
                  ))
                )}
              </Select>
            )}
          </FormControl>

          <label className="input-label" htmlFor="idCandidat">
            TALENT MANAGER
          </label>
          <FormControl variant="outlined" fullWidth={true} margin="normal">
            <InputLabel
              {...(errors.consultant && {
                error: true,
              })}
              shrink
            >
              {errors.consultant}
            </InputLabel>
            {loadUsers ? (
              <Box display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            ) : (
              <Select
                value={talentManager}
                name="talentManager"
                onChange={(e) => setTalentManager(e.target.value)}
                {...(errors.consultant && {
                  error: true,
                })}
                input={
                  <OutlinedInput
                    name="talentManager"
                    {...(errors.consultant && {
                      labelWidth: 290,
                    })}
                    notched
                  ></OutlinedInput>
                }
              >
                {loadUsers ? (
                  <CircularProgress />
                ) : (
                  talentManagers.map((talentManager) => (
                    <MenuItem value={talentManager.uuid} key={talentManager.uuid}>
                      <span style={{ textTransform: "capitalize" }}>
                        {talentManager.user}
                      </span>
                    </MenuItem>
                  ))
                )}
              </Select>
            )}
          </FormControl>

          <label className="input-label" htmlFor="idCandidat">
            SOURCEUR
          </label>
          <FormControl variant="outlined" fullWidth={true} margin="normal">
            <InputLabel
              {...(errors.consultant && {
                error: true,
              })}
              shrink
            >
              {errors.consultant}
            </InputLabel>
            {loadUsers ? (
              <Box display="flex" justifyContent="center">
                <CircularProgress />
              </Box>
            ) : (
              <Select
                value={sourceur}
                name="sourceur"
                onChange={(e) => setSourceur(e.target.value)}
                {...(errors.sourceur && {
                  error: true,
                })}
                input={
                  <OutlinedInput
                    name="sourceur"
                    {...(errors.sourceur && {
                      labelWidth: 290,
                    })}
                    notched
                  ></OutlinedInput>
                }
              >
                {loadUsers ? (
                  <CircularProgress />
                ) : (
                  managers?.map((sourceur) => (
                    <MenuItem value={sourceur.uuid} key={sourceur.uuid}>
                      <span style={{ textTransform: "capitalize" }}>
                        {sourceur.user}
                      </span>
                    </MenuItem>
                  ))
                )}
              </Select>
            )}
          </FormControl>
          <label className="input-label" htmlFor="idCandidat">
            SACHEZ QUE<span className="required-input"></span>
          </label>
          <TextField
            multiLine
            minRows={4}
            value={sachezque}
            name="sachezque"
            onChange={(e) => {
              setSachezQue(e.target.value);
              setSachezQueCounter(300 - e.target.value.length);
            }}
            variant="outlined"
            placeholder="Plus d'informations sur le candidat."
            fullWidth={true}
            margin="normal" slotProps={{ htmlInput: { maxLength: 300 } }}
          />
          {sachezQueCounter || 300}
        </Card>
      </Grid>
    </>
  );
};
